import { NgModule, ModuleWithProviders, ErrorHandler } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { IClientSideLogger } from '@nimbus-library/features/logger/services/client-logger/i-client-side-logger';
import { signalRLoggingEnabledKey } from '@nimbus-global/features/shared/i-app.configuration';
import { ClientSideLogger } from '@nimbus-library/features/logger/services/client-logger/client-side-logger.service';
import { NoopClientSideLogger } from '@nimbus-library/features/logger/services/client-logger/noop-client-side-logger';
import { LOGGER } from './models/configuration.model';
import { AggregatedLoggerService } from './services/logger/aggregated-logger.service';
import { ILoggerConfiguration } from './models/i-cloud-logger-configuration.model';
import { LogErrorHandler } from './services/error-handler.service';
import { ConsoleLogger } from './services/logger/console.logger';
import { ILogger } from './services/logger/i-logger';
import { LOG_APP_NAME, LOG_CONFIG } from './services/logger/logger-configuration';

export interface ILoggingModuleConfiguration {
  loggingConfiguration: ILoggerConfiguration;
}

export function clientLoggerFactory(): IClientSideLogger {
  return sessionStorage && sessionStorage[signalRLoggingEnabledKey] === 'true' ? new ClientSideLogger() : new NoopClientSideLogger();
}

@NgModule({ imports: [], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class LoggingModule {
  public static forRoot(loggingConfiguration: ILoggingModuleConfiguration, applicationName: string): ModuleWithProviders<LoggingModule> {
    return {
      ngModule: LoggingModule,
      providers: [
        { provide: LOG_CONFIG, useValue: loggingConfiguration.loggingConfiguration },
        { provide: LOG_APP_NAME, useValue: applicationName },
        { provide: LOGGER, useClass: ConsoleLogger, multi: true },
        { provide: ILogger, useClass: AggregatedLoggerService },
        { provide: ErrorHandler, useClass: LogErrorHandler },
        { provide: IClientSideLogger, useFactory: clientLoggerFactory },
      ],
    };
  }
}
